import React, { useEffect, useContext } from "react";
import "../Components/Orders/Orders.css";
import { techappContext } from "../../Api/techappReq";
import OrderCard from "../Components/order_card";
import { Skeleton } from "antd";
import Empty from "../Components/empty";

const SpecialOrders = () => {
  const skeletonItems = [1, 1, 1, 1];

  const { getOrder, orders, loading } = useContext(techappContext);

  useEffect(() => {
    getOrder("special");
  }, []);

  return (
    <div className="tech-app-orders-container">
      {/* list view */}
      {!loading &&
        orders?.special?.length > 0 &&
        orders?.special?.map((order, index) => (
          <OrderCard
            order={order}
            index={index}
            type={order.status_name}
            labelColor={"#0180ff"}
          />
        ))}
      {/* empty list */}
      {!loading && orders?.special?.length === 0 && (
        <Empty title={"سفارشی یافت نشد."} />
      )}
      {/* skeleton loading */}
      {loading &&
        skeletonItems.map((item, index) => (
          <Skeleton.Button
            style={{
              width: "100%",
              height: "130px",
              marginBottom: "10px",
              borderRadius: "8px",
            }}
            shape={"square"}
            active
            key={index}
          />
        ))}
    </div>
  );
};
export default SpecialOrders;
